import { toWei } from 'helpers';
import { StakingPoolItemData } from 'models';

export const postUnstake = async (
  stakingPoolItemData: StakingPoolItemData,
  unstakingValue: string,
  decimals: number,
  connectedAddress: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  const unstakingValueWei = toWei(unstakingValue, decimals);

  return await stakingPoolItemData.stakingPoolItemContract.methods
    .unstake(unstakingValueWei)
    .send({
      from: connectedAddress,
      maxPriorityFeePerGas: null,
      maxFeePerGas: null,
    });
};
